import Axios from "./axios";

const endpoint = "/api/company";
export default {
  //회사등록
  //{"companyName": "string","companyType": "string"}
  companyCreate: (data) => Axios.post(`${endpoint}/create`, data),

  //회사삭제
  //{"companyId": 0}
  companyDelete: (data) => Axios.post(`${endpoint}/delete`, data),

  //현장 조건별 조회
  //{"companyName": "string","companyType": "string"}
  companyFilter: (data) => Axios.post(`${endpoint}/filter-list`, data),

  //현장정보수정
  //{"companyId": 0,"companyName": "string","companyType": "string"}
  companyUpdate: (data) => Axios.post(`${endpoint}/update`, data),

  //현장정보수정
  //{"companyId": 0}
  companyInformation: (data) => Axios.post(`${endpoint}/information`, data),

  //업체별 목록조회
  //{"companyType": "string"}
  companyClistInType: (data) => Axios.post(`${endpoint}/clist-in-type`, data),

  //전체현장목록조회
  companyTotalList: (data) => Axios.post(`${endpoint}/total-list`, data),
};
